// src/utils/savePdf.js
//
// Saves a jsPDF document as a real file download.
//
// Why not doc.save()? jsPDF's save() *opens* the PDF in a viewer tab on
// iPhones and on several Android browsers instead of downloading it.
// Here the file is handed to the browser as a generic binary download
// (application/octet-stream) with a file name, so phones and laptops
// save it to Downloads / Files instead of previewing it.

export function savePdf(doc, filename) {
  const pdf  = doc.output('blob');
  const blob = new Blob([pdf], { type: 'application/octet-stream' });

  // Old Edge / IE
  if (window.navigator && typeof window.navigator.msSaveOrOpenBlob === 'function') {
    window.navigator.msSaveOrOpenBlob(blob, filename);
    return;
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();

  // Keep the link alive for a while — iOS needs time to start the download
  setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 60000);
}
